/* eslint-disable @typescript-eslint/naming-convention, no-underscore-dangle -- webpack injects this global */
/** Webpack `output.publicPath` — Packrat sets this to the build-cdn TrePreview URL (ends with `/`). */
declare const __webpack_public_path__: string;
declare const BUILD_ENV: string;

/**
 * Absolute URL prefix for `video.html` / `image.html` shipped with this TrePreview build
 * (no trailing slash).
 *
 * Production: `{webpack publicPath}previewers` on build-cdn (same deploy as the bundle).
 * Development: `{origin}/previewers` on the webpack dev server.
 */
export function getPreviewersBaseUrl(): string {
  if (BUILD_ENV === "development") {
    return `${window.location.origin}/previewers`;
  }
  let publicPath =
    typeof __webpack_public_path__ === "string" ? __webpack_public_path__ : "";
  if (!publicPath || publicPath === "auto") {
    publicPath = `${window.location.origin}/`;
  }
  if (!publicPath.endsWith("/")) {
    publicPath = `${publicPath}/`;
  }
  return `${publicPath}previewers`;
}

/** Origin that hosts the previewer iframes (for `postMessage` allowlists). */
export function getPreviewersOrigin(): string {
  return new URL(`${getPreviewersBaseUrl()}/`).origin;
}
